/** The full-page wall an archived company sees instead of the app (PREC-3900). */
export const enArchivedAccount = {
	title: "Your account is archived",
	description:
		"Your subscription ended and the read-only period has passed, so your lists, leads and message history are no longer accessible.",
	/** `<0>` wraps the date in `<b>` — see the `components` prop on the `<Trans>` call site. */
	deletionNotice:
		"All of it is permanently deleted on <0>{{date}}</0>. Reactivating before then restores your account exactly as you left it.",
	/**
	 * Shown once the deletion date has passed. The GDPR purge ships dark
	 * (`COMPANY_HARD_DELETE_ENABLED=false`), so every company that reaches day 90 sits in
	 * `DUE_FOR_DELETION` with a date in the past — and the notice above would then tell the
	 * customer their data was destroyed while we still hold it. This keeps the pressure (deletion
	 * is imminent, reactivating still works right now) without asserting a deletion that has not
	 * happened.
	 */
	deletionNoticeOverdue:
		"Your data is past its deletion date of <0>{{date}}</0> and is now scheduled for permanent deletion. Reactivating now still restores your account exactly as you left it — once it is deleted, it cannot be recovered.",
	reactivateCta: "Reactivate my subscription",
};
